import React, { useState, useEffect } from 'react';
import { recipesAPI } from '../../services/api';
import RecipeCard from '../common/RecipeCard';
import './Recipes.css';

export default function CollectionPage() {
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    recipesAPI.getCollection()
      .then(data => setRecipes(data.recipes))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="collection-page">
      <div className="page-header">
        <h1>My Collection</h1>
        <p>Recipes you've saved</p>
      </div>

      {loading ? (
        <div className="loading-center"><div className="spinner" /></div>
      ) : recipes.length === 0 ? (
        <div className="empty-state">
          <span className="empty-icon">📚</span>
          <h3>Your collection is empty</h3>
          <p>Browse recipes and tap the bookmark icon to save them here</p>
        </div>
      ) : (
        <div className="recipe-grid">
          {recipes.map(r => <RecipeCard key={r._id} recipe={r} />)}
        </div>
      )}
    </div>
  );
}
